/**
* @license Apache-2.0
*
* Copyright (c) 2024 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

import format from '@stdlib/error-tools-fmtprodmsg';

// MODULES //

import Buffer from '@stdlib/buffer-ctor';

import Float64Array from '@stdlib/array-float64';
import Float32Array from '@stdlib/array-float32';
import Float16Array from '@stdlib/array-float16';
import Int16Array from '@stdlib/array-int16';
import Int32Array from '@stdlib/array-int32';
import Int8Array from '@stdlib/array-int8';
import Uint16Array from '@stdlib/array-uint16';
import Uint32Array from '@stdlib/array-uint32';
import Uint8Array from '@stdlib/array-uint8';
import Uint8ClampedArray from '@stdlib/array-uint8c';
import Complex64Array from '@stdlib/array-complex64';
import Complex128Array from '@stdlib/array-complex128';
import BooleanArray from '@stdlib/array-bool';

// FUNCTIONS //

/**
* Throws an error.
*
* @private
* @throws {Error} not implemented
*/
function notImplemented() {
	throw new Error( format('0i900') );
}

// MAIN //

// Mapping from data types to underlying buffer constructors...
var ctors = { // eslint-disable-line vars-on-top
	'binary': Buffer,
	'float64': Float64Array,
	'float32': Float32Array,
	'float16': Float16Array,
	'generic': Array, // TODO: replace with `stdlib` pkg
	'int16': Int16Array,
	'int32': Int32Array,
	'int8': Int8Array,
	'uint16': Uint16Array,
	'uint32': Uint32Array,
	'uint8': Uint8Array,
	'uint8c': Uint8ClampedArray,
	'complex32': notImplemented, // FIXME: replace with Complex32Array constructor once implemented
	'complex64': Complex64Array,
	'complex128': Complex128Array,
	'bool': BooleanArray
};

// EXPORTS //

export default ctors;
